import { useRef } from "react";

interface ICheckboxProps {
  name: string;
  value?: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  error?: string;
  label?: string;
  required?: boolean;
}

const Checkbox = ({ name, value, onChange, disabled, className, error, label, required }: ICheckboxProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <div className="controlled-checkbox-container">
      <input
        ref={inputRef}
        id={name}
        type="checkbox"
        checked={value || false}
        onChange={handleChange}
        disabled={disabled}
        className={`controlled-checkbox-input ${className || ""} ${error ? "error" : ""}`}
      />
      <label htmlFor={name} className={`controlled-checkbox-label ${error ? "error" : ""}`}>
        {label}
        {required && <span className="controlled-checkbox-required"> *</span>}
      </label>
      {error && <small className="controlled-checkbox-error">{error}</small>}
    </div>
  );
};

export default Checkbox;
